import BACK from '../../assets/ClassicDeck/BACK.png'
import CLUB9 from '../../assets/ClassicDeck/CLUB-9.png'
import CLUB10 from '../../assets/ClassicDeck/CLUB-10.png'
import CLUBA from '../../assets/ClassicDeck/CLUB-A.png'
import CLUBJ from '../../assets/ClassicDeck/CLUB-J.png'
import CLUBK from '../../assets/ClassicDeck/CLUB-K.png'
import CLUBQ from '../../assets/ClassicDeck/CLUB-Q.png'
import DIAMOND9 from '../../assets/ClassicDeck/DIAMOND-9.png'
import DIAMOND10 from '../../assets/ClassicDeck/DIAMOND-10.png'
import DIAMONDA from '../../assets/ClassicDeck/DIAMOND-A.png'
import DIAMONDJ from '../../assets/ClassicDeck/DIAMOND-J.png'
import DIAMONDK from '../../assets/ClassicDeck/DIAMOND-K.png'
import DIAMONDQ from '../../assets/ClassicDeck/DIAMOND-Q.png'
import HEART9 from '../../assets/ClassicDeck/HEART-9.png'
import HEART10 from '../../assets/ClassicDeck/HEART-10.png'
import HEARTA from '../../assets/ClassicDeck/HEART-A.png'
import HEARTJ from '../../assets/ClassicDeck/HEART-J.png'
import HEARTK from '../../assets/ClassicDeck/HEART-K.png'
import HEARTQ from '../../assets/ClassicDeck/HEART-Q.png'
import SPADE9 from '../../assets/ClassicDeck/SPADE-9.png'
import SPADE10 from '../../assets/ClassicDeck/SPADE-10.png'
import SPADEA from '../../assets/ClassicDeck/SPADE-A.png'
import SPADEJ from '../../assets/ClassicDeck/SPADE-J.png'
import SPADEK from '../../assets/ClassicDeck/SPADE-K.png'
import SPADEQ from '../../assets/ClassicDeck/SPADE-Q.png'

export const CLASSICDECKLITE = {
  cards: [
    // CLUB
    {
      name: 'CLUB 9',
      src: CLUB9,
      matchID: 'BLACK9',
    },
    {
      name: 'CLUB 10',
      src: CLUB10,
      matchID: 'BLACK10',
    },
    {
      name: 'CLUB J',
      src: CLUBJ,
      matchID: 'BLACKJ',
    },
    {
      name: 'CLUB Q',
      src: CLUBQ,
      matchID: 'BLACKQ',
    },
    {
      name: 'CLUB K',
      src: CLUBK,
      matchID: 'BLACKK',
    },
    {
      name: 'CLUB A',
      src: CLUBA,
      matchID: 'BLACKA',
    },
    // SPADE

    {
      name: 'SPADE 9',
      src: SPADE9,
      matchID: 'BLACK9',
    },
    {
      name: 'SPADE 10',
      src: SPADE10,
      matchID: 'BLACK10',
    },
    {
      name: 'SPADE J',
      src: SPADEJ,
      matchID: 'BLACKJ',
    },
    {
      name: 'SPADE Q',
      src: SPADEQ,
      matchID: 'BLACKQ',
    },
    {
      name: 'SPADE K',
      src: SPADEK,
      matchID: 'BLACKK',
    },
    {
      name: 'SPADE A',
      src: SPADEA,
      matchID: 'BLACKA',
    },
    // DIAMONDS

    {
      name: 'DIAMOND 9',
      src: DIAMOND9,
      matchID: 'RED9',
    },
    {
      name: 'DIAMOND 10',
      src: DIAMOND10,
      matchID: 'RED10',
    },
    {
      name: 'DIAMOND J',
      src: DIAMONDJ,
      matchID: 'REDJ',
    },
    {
      name: 'DIAMOND Q',
      src: DIAMONDQ,
      matchID: 'REDQ',
    },
    {
      name: 'DIAMOND K',
      src: DIAMONDK,
      matchID: 'REDK',
    },
    {
      name: 'DIAMOND A',
      src: DIAMONDA,
      matchID: 'REDA',
    },
    // HEARTS

    {
      name: 'HEART 9',
      src: HEART9,
      matchID: 'RED9',
    },
    {
      name: 'HEART 10',
      src: HEART10,
      matchID: 'RED10',
    },
    {
      name: 'HEART J',
      src: HEARTJ,
      matchID: 'REDJ',
    },
    {
      name: 'HEART Q',
      src: HEARTQ,
      matchID: 'REDQ',
    },
    {
      name: 'HEART K',
      src: HEARTK,
      matchID: 'REDK',
    },
    {
      name: 'HEART A',
      src: HEARTA,
      matchID: 'REDA',
    },
  ],
  cover: {
    name: 'cover',
    src: BACK,
  },
}

// export const CLASSICDECKLITE = {
//   cards: [
//     // CLUB
//     {
//       name: 'CLUB 9',
//       src: CLUB9,
//       matchID: 'BLACK9',
//     },
//     {
//       name: 'CLUB 10',
//       src: CLUB10,
//       matchID: 'BLACK10',
//     },

//     // SPADE

//     {
//       name: 'SPADE 9',
//       src: SPADE9,
//       matchID: 'BLACK9',
//     },
//     {
//       name: 'SPADE 10',
//       src: SPADE10,
//       matchID: 'BLACK10',
//     },

//     // DIAMONDS

//     {
//       name: 'DIAMOND 9',
//       src: DIAMOND9,
//       matchID: 'RED9',
//     },
//     {
//       name: 'DIAMOND 10',
//       src: DIAMOND10,
//       matchID: 'RED10',
//     },

//     // HEARTS

//     {
//       name: 'HEART 9',
//       src: HEART9,
//       matchID: 'RED9',
//     },
//     {
//       name: 'HEART 10',
//       src: HEART10,
//       matchID: 'RED10',
//     },
//   ],
//   cover: {
//     name: 'cover',
//     src: BACK,
//   },
// }
